const tabTournoiInterne = [
  {
    id: 0,
    category: "Dames",
    result: [
      {
        season: "2002",
        WinnerName: "DEBOST Camille",
        WinnerRanking: "30",
        LoserName: "MORIN Marie-Hélène",
        LoserRanking: "30/4",
      },
      {
        season: "2003",
        WinnerName: "CEDDIA Laurence",
        WinnerRanking: "30/3",
        LoserName: "CEDDIA Laurie",
        LoserRanking: "30",
      },
      {
        season: "2004",
        WinnerName: "CHANU Aurélie",
        WinnerRanking: "15/5",
        LoserName: "CEDDIA Laurie",
        LoserRanking: "30",
      },
      {
        season: "2005",
        WinnerName: "CEDDIA Laurie",
        WinnerRanking: "15/5",
        LoserName: "CHANU Aurélie",
        LoserRanking: "15/5",
      },
      {
        season: "2006",
        WinnerName: "CEDDIA Laurence",
        WinnerRanking: "30/1",
        LoserName: "CEDDIA Laurie",
        LoserRanking: "15/4",
      },
      {
        season: "2007",
        WinnerName: "CEDDIA Laurie",
        WinnerRanking: "15/4",
        LoserName: "CEDDIA Laurence",
        LoserRanking: "15/5",
      },
      {
        season: "2008",
        WinnerName: "BESSON Morgane",
        WinnerRanking: "15/2",
        LoserName: "CEDDIA Laurie",
        LoserRanking: "15/2",
      },
      {
        season: "2009",
        WinnerName: "DEFALLETANS Marie",
        WinnerRanking: "15/4",
        LoserName: "CEDDIA Laurie",
        LoserRanking: "15/2",
      },
      {
        season: "2010",
        WinnerName: "BESSON Morgane",
        WinnerRanking: "15/1",
        LoserName: "CEDDIA Laurie",
        LoserRanking: "15/3",
      },
      {
        season: "2011",
        WinnerName: "CEDDIA Laurie",
        WinnerRanking: "15/4",
        LoserName: "CEDDIA Laurence",
        LoserRanking: "30/1",
      },
      {
        season: "2012",
        WinnerName: "CEDDIA Laurie",
        WinnerRanking: "15/3",
        LoserName: "BESSON Morgane",
        LoserRanking: "15/3",
      },
      {
        season: "2013",
        WinnerName: "CEDDIA Laurie",
        WinnerRanking: "15/1",
        LoserName: "CEDDIA Alexandra",
        LoserRanking: "30",
      },
      {
        season: "2014",
        WinnerName: "MASSOT Morgane",
        WinnerRanking: "15/5",
        LoserName: "RENAUD Eugénie",
        LoserRanking: "30/2",
      },
      {
        season: "2015",
        WinnerName: "CEDDIA LAURENCE",
        WinnerRanking: "30/2",
        LoserName: "BESSON Morgane",
        LoserRanking: "15/4",
      },
      {
        season: "2016",
        WinnerName: "CEDDIA LAURIE",
        WinnerRanking: "15/3",
        LoserName: "DEFALLETANS Clotilde",
        LoserRanking: "30/2",
      },
      {
        season: "2017",
        WinnerName: "CEDDIA LAURIE",
        WinnerRanking: "15/3",
        LoserName: "DEFALLETANS Clotilde",
        LoserRanking: "15/5",
      },
      {
        season: "2018",
        WinnerName: "PETIT Natacha",
        WinnerRanking: "30",
        LoserName: "MARECHAL Gaëlle",
        LoserRanking: "30/2",
      },
      {
        season: "2019",
        WinnerName: "-",
        WinnerRanking: "-",
        LoserName: "-",
        LoserRanking: "-",
      },
      {
        season: "2020",
        WinnerName: "COVID",
        WinnerRanking: "-",
        LoserName: "COVID",
        LoserRanking: "-",
      },
      {
        season: "2021",
        WinnerName: "COVID",
        WinnerRanking: "-",
        LoserName: "COVID",
        LoserRanking: "-",
      },
      {
        season: "2022",
        WinnerName: "PERRIN Lucie",
        WinnerRanking: "15/4",
        LoserName: "ALBAN Éléna",
        LoserRanking: "30/3",
      },
      {
        season: "2023",
        WinnerName: "PERRIN Lucie",
        WinnerRanking: "15/4",
        LoserName: "ALBAN Éléna",
        LoserRanking: "30/3",
      },
      {
        season: "2024",
        WinnerName: "PERRIN Lucie",
        WinnerRanking: "15/3",
        LoserName: "DEFALLETANS Clotilde",
        LoserRanking: "30/3",
      },
      {
        season: "2025",
        WinnerName: "CATHERIN Charlotte",
        WinnerRanking: "30/1",
        LoserName: "GRANGER Noémie",
        LoserRanking: "30/2",
      },
      {
        season: "2026",
        WinnerName: "GRANGER Noémie",
        WinnerRanking: "30/1",
        LoserName: "DI MAJO Stéphanie",
        LoserRanking: "30/2",
      },
    ],
  },
  {
    id: 1,
    category: "Messieurs",
    result: [
      {
        season: "2002",
        WinnerName: "BESSON Yvan",
        WinnerRanking: "15/4",
        LoserName: "BERRY Eric",
        LoserRanking: "15/2",
      },
      {
        season: "2003",
        WinnerName: "BESSON Yvan",
        WinnerRanking: "15/4",
        LoserName: "BERRY Eric",
        LoserRanking: "15/3",
      },
      {
        season: "2004",
        WinnerName: "BESSON Yvan",
        WinnerRanking: "15/3",
        LoserName: "RATTON Benjamin",
        LoserRanking: "15/5",
      },
      {
        season: "2005",
        WinnerName: "BESSON Yvan",
        WinnerRanking: "15/3",
        LoserName: "GONOD Stéphane",
        LoserRanking: "15/4",
      },
      {
        season: "2006",
        WinnerName: "TOROSSIAN Philippe",
        WinnerRanking: "15/3",
        LoserName: "BERRY Bertrand",
        LoserRanking: "15/3",
      },
      {
        season: "2007",
        WinnerName: "GAUVRIT Frédéric",
        WinnerRanking: "15/3",
        LoserName: "BESSON Yvan",
        LoserRanking: "15/3",
      },
      {
        season: "2008",
        WinnerName: "BESSON Yvan",
        WinnerRanking: "15/2",
        LoserName: "GAUVRIT Frédéric",
        LoserRanking: "15/2",
      },
      {
        season: "2009",
        WinnerName: "TOROSSIAN Philippe",
        WinnerRanking: "15/2",
        LoserName: "RATTON Benjamin",
        LoserRanking: "15/5",
      },
      {
        season: "2010",
        WinnerName: "BESSON Yvan",
        WinnerRanking: "15/3",
        LoserName: "LEROUX Mathieu",
        LoserRanking: "15/3",
      },
      {
        season: "2011",
        WinnerName: "LEROUX Mathieu",
        WinnerRanking: "15/2",
        LoserName: "GAUVRIT Frédéric",
        LoserRanking: "15/1",
      },
      {
        season: "2012",
        WinnerName: "LEROUX Mathieu",
        WinnerRanking: "15/1",
        LoserName: "MARTIN Pierrick",
        LoserRanking: "15/3",
      },
      {
        season: "2013",
        WinnerName: "LEROUX Mathieu",
        WinnerRanking: "15/1",
        LoserName: "BEYNEL Pascal",
        LoserRanking: "15/1",
      },
      {
        season: "2014",
        WinnerName: "VIDON Alexandre",
        WinnerRanking: "15/3",
        LoserName: "MIGEON Cyril",
        LoserRanking: "15/2",
      },
      {
        season: "2015",
        WinnerName: "GAUVRIT Frédéric",
        WinnerRanking: "15/3",
        LoserName: "LEROUX Mathieu",
        LoserRanking: "15/3",
      },
      {
        season: "2016",
        WinnerName: "GAUVRIT Frédéric",
        WinnerRanking: "15/3",
        LoserName: "VIDON Alexandre",
        LoserRanking: "15/3",
      },
      {
        season: "2017",
        WinnerName: "VIDON Alexandre",
        WinnerRanking: "15/4",
        LoserName: "GAUVRIT Frédéric",
        LoserRanking: "15/3",
      },
      {
        season: "2018",
        WinnerName: "JARILLO Evan",
        WinnerRanking: "15/1",
        LoserName: "BRESSAN Loïc",
        LoserRanking: "15/1",
      },
      {
        season: "2019",
        WinnerName: "JARILLO Evan",
        WinnerRanking: "5/6",
        LoserName: "DU ROURE Ludovic",
        LoserRanking: "15/1",
      },
      {
        season: "2020",
        WinnerName: "COVID",
        WinnerRanking: "-",
        LoserName: "COVID",
        LoserRanking: "-",
      },
      {
        season: "2021",
        WinnerName: "COVID",
        WinnerRanking: "-",
        LoserName: "COVID",
        LoserRanking: "-",
      },
      {
        season: "2022",
        WinnerName: "DU ROURE Ludovic",
        WinnerRanking: "15/2",
        LoserName: "PERRIN Thomas",
        LoserRanking: "15/5",
      },
      {
        season: "2023",
        WinnerName: "DU ROURE Ludovic",
        WinnerRanking: "15/2",
        LoserName: "SINIBALDI Thomas",
        LoserRanking: "15/5",
      },
      {
        season: "2024",
        WinnerName: "DU ROURE Ludovic",
        WinnerRanking: "15/2",
        LoserName: "PENIN Gonzague",
        LoserRanking: "30/1",
      },
      {
        season: "2025",
        WinnerName: "LAMORT Charles-Étienne",
        WinnerRanking: "15/3",
        LoserName: "DU ROURE Ludovic",
        LoserRanking: "15/2",
      },
      {
        season: "2026",
        WinnerName: "DEFALLETANS Benoît",
        WinnerRanking: "15/4",
        LoserName: "PENIN Gonzague",
        LoserRanking: "30",
      },
    ],
  },
];

export default tabTournoiInterne;
